import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';

import config from 'config/config';

firebase.initializeApp(config.firebase);
firebase.firestore().settings(config.firestore);

export { firebase };
